import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ILogCallJobInfo, ILogCallTaskInfo } from '../../../interfaces/telephony/log-call-job-info';

@Component({
  selector: 'telephony-control-task-table',
  templateUrl: './telephony-control-task-table.component.html',
  styleUrls: ['./telephony-control-task-table.component.scss'],
})
export class TelephonyControlTaskTableComponent {
  @Input() public jobInfo: ILogCallJobInfo;
  @Input() public selectedTask: ILogCallTaskInfo;
  @Output() public selectedTaskChange = new EventEmitter<ILogCallTaskInfo>();

  onTaskClick(task: ILogCallTaskInfo, i: number) {
    this.selectedTaskChange.emit(task);
  }
}
